import { ModelBase } from '../../core/model/model-base';

export class LeaseAgreementForm extends ModelBase {
  constructor() {
    super();
  }

  caption: string;
  code: string;
  codeCaption: string;
  created: Date;

  toJSON() {
    return { caption: this.caption };
  }
}
